import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface ImportRecalculationErrorsListGridActionCellRendererParams extends ICellRendererParams {
    canEdit: boolean;
    recalculate: (params: ImportRecalculationErrorsListGridActionCellRendererParams) => void;
}

@Component({
    selector: 'import-recalculation-errors-list-grid-action-cell',
    template:
        `@if (params && params.data && !isAcknowledged) {
  <button type="button"
    class="ace-btn btn-primary has-icon grid-action-button"
    [disabled]="!params.canEdit || isRunning"
    (click)="params.recalculate(params)"
    helpTooltip
    helpContentId="import-recalculation-errors-list.recalculate"
    position="bottom">
    <i class="fa fa-refresh"></i>
  </button>
}`,
    styles: [
        `:host {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
        }`
    ],
    standalone: false
})
export class ImportRecalculationErrorsListGridActionCellRendererComponent implements ICellRendererAngularComp {
    params: ImportRecalculationErrorsListGridActionCellRendererParams;

    get isRunning(): boolean {
        const row = this.params.data as Compliance.ImportFileActivityErrorModel;
        return row && (row.recalculationStatus === Compliance.ImportFileActivityErrorRecalculationStatusEnum.Queued ||
            row.recalculationStatus === Compliance.ImportFileActivityErrorRecalculationStatusEnum.Running);
    }

    get isAcknowledged(): boolean {
        const row = this.params.data as Compliance.ImportFileActivityErrorModel;
        return !!(row && row.isAcknowledged);
    }

    agInit(params: ImportRecalculationErrorsListGridActionCellRendererParams): void {
        this.params = params;
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }
}
